import useAppView from 'Core/Hooks/useAppView'
import { SummaryHeader, getResourceName, getRsrcIcon, useResourceDetails } from 'features/resources'
import React from 'react'
import { useHistory } from 'react-router'

function ResourceDetailsView({ HeaderActions, children, catalogPage = 'targets' }) {
  const { rsrc } = useResourceDetails()
  const { appView } = useAppView()

  const history = useHistory()

  const DEFAULT_BREADCRUMBS = [
    {
      label: 'Targets',
      link: `/${appView}/${catalogPage}`
    },
    {
      label: getResourceName(rsrc),
      link: null
    }
  ]

  const getBreadcrumbsElements = () => {
    // @ts-ignore
    const fromHistory = history.location.state?.from || []
    if (!fromHistory.length) return DEFAULT_BREADCRUMBS

    return fromHistory.map((h) => ({
      label: h.name,
      link: h.url
    }))
  }

  if (!rsrc) return null

  return (
    <div className='bg-[var(--color-common-bg-secondary)]'>
      <div className='-mx-4 -mt-6 p-4'>
        <SummaryHeader
          Icon={getRsrcIcon(rsrc)}
          rsrcName={getResourceName(rsrc)}
          actions={HeaderActions}
          breadCrumbsItems={getBreadcrumbsElements()}
        />
      </div>
      <div className='p-4 bg-[var(--color-common-bg-base)] min-h-screen'>{children}</div>
    </div>
  )
}

export { ResourceDetailsView }
